export enum Step {
    PLATFORMS = "PLATFORMS",
    TOPICS = "TOPICS",
    SELF_HELP = "SELF_HELP",
    DETAILS = "DETAILS"
}